export const setVerticalScrollbar = (newWindowHeight: number): void => {
  const screenHeight = window.screen.height;

  if (newWindowHeight < screenHeight) {
    document.body.style.overflowY = "hidden";
  } else {
    document.body.style.overflowY = "auto";
  }
};
